export default "__VITE_ASSET__0HCAPDL$__"